// extracted by mini-css-extract-plugin
module.exports = {"item":"NotificationItem_item__oUr5Z","type":"NotificationItem_type__qIzM6","date":"NotificationItem_date__us9Wo"};